import React from 'react'
import map from 'lodash/map'

import FeatureSelectionCard from './FeatureSelectionCard'

const FEATURES = [
  {
    id: 'viral-clips',
    icon: '✂️',
    title: 'Viral Clips',
    subtitle: 'For TikTok, Shorts, Reels',
  },
  {
    id: 'subtitles',
    icon: '📝',
    title: 'Subtitles',
    subtitle: 'High accuracy captions',
  },
  {
    id: 'ai-dubbing',
    icon: '🎙️',
    title: 'AI Dubbing',
    subtitle: 'Translate with natural AI voices',
  },
]

interface FeatureSelectionRowProps {
  readonly selectedId: string
  readonly aiDubbingAvailable: boolean
  onSelect(id: string): void
}

const FeatureSelectionRow: React.FC<FeatureSelectionRowProps> = (props) => {
  const { selectedId, aiDubbingAvailable, onSelect } = props

  const handleSelectViralClips = () => {
    onSelect('viral-clips')
  }

  const handleSelectSubtitles = () => {
    onSelect('subtitles')
  }

  const handleSelectAiDubbing = () => {
    onSelect('ai-dubbing')
  }

  const handlers: Record<string, () => void> = {
    'viral-clips': handleSelectViralClips,
    'subtitles': handleSelectSubtitles,
    'ai-dubbing': handleSelectAiDubbing,
  }

  return (
    <div className="QuickStart__feature-section">
      <h2 className="QuickStart__section-heading">What would you like to generate?</h2>
      <div className="QuickStart__feature-row">
        {map(FEATURES, feature => (
          <FeatureSelectionCard
            key={feature.id}
            id={feature.id}
            icon={feature.icon}
            title={feature.title}
            subtitle={feature.subtitle}
            selected={selectedId === feature.id}
            disabled={feature.id === 'ai-dubbing' && !aiDubbingAvailable}
            onClick={handlers[feature.id]}
          />
        ))}
      </div>
    </div>
  )
}

export default FeatureSelectionRow
